import C from '../common/C';
import { aqiSmoothColor } from '../common/colors';
import { conc2aqi } from '../common/scale';
import './tooltip.scss';
var StationTooltip = /** @class */ (function () {
    function StationTooltip() {
        var tooltip = document.createElement('div');
        this.domnode = tooltip;
        tooltip.className = 'tooltips';
        document.body.appendChild(tooltip);
        this.tooltip = C.select(tooltip).c('p', 'OnRight').html('');
        this.hide();
    }
    StationTooltip.prototype.hide = function () {
        this.domnode.style.visibility = 'hidden';
        if (this.graphView)
            this.graphView.cancel();
        this.graphView = null;
        this.activeStation = null;
    };
    StationTooltip.prototype.show = function (point, station, specie) {
        this.domnode.style.visibility = '';
        this.domnode.style.top = point.y + 'px';
        this.domnode.style.left = point.x + 'px';
        if (this.graphView)
            this.graphView.cancel();
        this.graphView = null;
        this.activeStation = station;
        this.render(station).then(function (x) {
            return;
            // if (this.activeStation != station) return
            // if (!x.readings.readings[specie]) return
            // let unit = x.readings.readings[specie].unit
            // /* If the tooltip has been changed ... cancel the view */
            // this.graphView = StationHourlyGraph.create(x.div)
            // this.graphView!.show(station, specie, unit, 3)
        });
    };
    StationTooltip.prototype.render = function (station) {
        var _this = this;
        return station.readings().then(function (readings) {
            if (!readings)
                throw "no readings";
            var name = "";
            try {
                name = readings.metadata.Data.name;
                if (name.en)
                    name = name.en.station;
                else if (name.my)
                    name = name.my.station;
                else if (name.cn)
                    name = name.cn.station;
                else if (name.vn)
                    name = name.vn.station;
            }
            catch (e) { }
            _this.tooltip
                .html('')
                .c('div', 'header', { maxWidth: "200px" })
                .html('<label>Feed:</label> ' +
                readings.metadata.Source +
                '<br>' +
                '<label>Station:</label> ' +
                readings.metadata.StationID +
                '<br>' +
                '<label>Name:</label> ' +
                name);
            var row = _this.tooltip
                .c('div', 'station-readings')
                .c('table')
                .c('tr');
            var species = Object.keys(readings.readings);
            species.sort();
            species.forEach(function (specie) {
                if (specie.indexOf('_lvl') > 0)
                    return;
                var reading = readings.readings[specie];
                var trow = row.node();
                var ttable = trow.parentNode;
                var e = new C(ttable.insertRow(trow.rowIndex + 1)).class('readings');
                var sdt = '';
                var ut = new Date(reading.time);
                var dt = (Date.now() - ut.getTime()) / 1000;
                if (dt < 3600) {
                    sdt = Math.round(dt / 60) + ' min';
                }
                else if (dt < 3600 * 24) {
                    sdt = Math.round(dt / 3600) + ' hour';
                }
                else if (dt < 3600 * 24 * 3) {
                    sdt = Math.round((dt * 10) / (24 * 3600)) / 10 + ' day';
                }
                else {
                    sdt = Math.round(dt / (24 * 3600)) + ' days';
                }
                var aqi = Math.round(conc2aqi(reading.value, specie, reading.unit));
                var bgcolor = aqiSmoothColor(aqi, 'b', specie);
                var fgcolor = aqiSmoothColor(aqi, 'f', specie);
                var block = "<div style='background-color:".concat(bgcolor, ";color:").concat(fgcolor, ";width:32px;height:16px;'>").concat(aqi, "</div>");
                e.html('<td>' +
                    specie +
                    '<td>' +
                    sdt +
                    '<td>' +
                    reading.value +
                    '<small> ' +
                    reading.unit +
                    '<td>' +
                    block);
            });
            return { div: _this.tooltip.c('div'), readings: readings };
        }).catch(function (e) {
            _this.tooltip.html("").c("div", { maxWidth: "120px", fontSize: "12px" })
                .html("Please login with your token to see the current readings for ".concat(station.source, " ").concat(station.idx));
            return { div: _this.tooltip.c('div') };
        });
    };
    return StationTooltip;
}());
export { StationTooltip };
